(function($) {
    $(() => {

        /* PAGE scroll */
        if($('.front-page').length || $('.activities-template').length) {
            if (window.location.hash) {
                var hash = window.location.hash;
               
                if ($(hash).length) {
                   setTimeout(function() {
                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(hash).offset().top - 100
                        }, 1500);
                   }, 500);
                }
            }
        }
    
        /* Match hight */
        $('.match-h').matchHeight({
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        });

        $('.match-h-no-row').matchHeight({
            byRow: false,
            property: 'height',
            target: null,
            remove: false
        });

        /* BAUGETTE BOX */
        baguetteBox.run('.js-gallery', {
            animation: 'fadeIn',
            noScrollbars: false,
            loop: true
        });

        /* MENU */
        $('.js-open-search').on('click', function() {
            $('.js-search-input').addClass('open');
            $('.js-search-input').trigger('focus');
        });

        $('.js-close-icon').on('click', function() {
            $('.js-search-input').removeClass('open');
        });

        //MENU TRANSFORM ON SCROLLING
        const nav = $('#menu');
        var lastScrollTop = 0;
       
        $(window).scroll(function () {
            let active_menu = false

          
            if($('.front-page').length !== 0) {
                if ($(window).scrollTop() > 50) {
                    nav.removeClass('front');
                } else {
                    nav.addClass('front');
                }
            }
        });

        $('.js-online-cb').on('change', function() {
            $('.no-online-case').toggleClass('hide');
        });

        $('.js-anchor-link').on('click', function() {
            const id = $(this).data('anchor');
            $([document.documentElement, document.body]).animate({
                scrollTop: $(id).offset().top - 100
            }, 1500);
        });

        /* SEARCHING */
        $('.js-delete-search').on('click', function(e) {
            e.preventDefault();
            $('.js-search-input').val('');
        });

        $('.js-submit').on('click', function() {
            $('.js-search-form').submit();
        });

         /* Scroll arrow */

        $(window).on('resize scroll', function() {
            const showOn = parseInt(($(document).outerHeight(true) * 0.3));
            const btnBackToTop = $('#btn-back-to-top');

            const scrollContainer = () => {
                return document.documentElement || document.body;
            };

            if (scrollContainer().scrollTop > showOn) {
                btnBackToTop.addClass('anim');
                btnBackToTop.css('bottom', '10px');
            } else {
                btnBackToTop.removeClass('anim');
                btnBackToTop.css('bottom', '-70px');
            }
		});

        $(document).on('click', '#btn-back-to-top', function() {
            $('html,body').animate({ scrollTop: 0 }, 'slow');
        });

        /* POPUP COOKIE */
        if(ajax.popup_active) {
            if (Cookies.get("cookie_popup") != "inactive") {
                $('.js-popup').modal('show')
            }    
        }
        $('.js-close-popup').on("click", function (){
            Cookies.set("cookie_popup", "inactive", {
                expires: parseInt(ajax.popup_expires)
            }); 
            $('.js-popup').modal('hide')
        });
    });
})(jQuery);
